export const API_ERROR = `APP::API_ERROR`;
export const APP_IS_LOADING = `APP::IS_LOADING`;
